export { default } from '../../_common/HeaderCell';
